module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/profile/profile.component.css
// module id = ./src/app/myprofile/profile/profile.component.css
// module chunks = main